import axios from "axios";
import store from "redux/Store";
import { __trackStatus } from "../../_clearance/definition/status";
import { __compileRules } from "../../_clearance/utils/utils";
module = "/clearanceRuntime";

// Cache for pending requests to prevent duplicate API calls
const pendingRequests = new Map();

// Cache for loaded runtime data
let cachedRuntimeData = null;
export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  ERROR: "ERROR" + module,
  CTAG: "CTAG" + module,
  CTAG_ERROR: "CTAG_ERROR" + module,
  RESET_CTAG: "RESET_CTAG" + module,
  SET_COPY_LIVE_IDS: "SET_COPY_LIVE_IDS" + module,
  REMOVE_COPY_LIVE_IDS: "REMOVE_COPY_LIVE_IDS" + module,
};

export const loadRuntime = (ruleCollection) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  // Create cache key based on ruleCollection parameter
  const cacheKey = `runtime_${ruleCollection ? "nr" : "all"}`;
  const { clearanceRuntime } = store.getState();

  // Return cached data if available
  if (cachedRuntimeData && clearanceRuntime?.data) {
    return dispatch({
      type: actionTypes.LOAD,
      payload: clearanceRuntime.data,
    });
  }

  // If a request is already in-flight, reuse it
  if (pendingRequests.has(cacheKey)) {
    return pendingRequests.get(cacheKey);
  }

  dispatch({
    type: actionTypes.LOADING,
  });

  const tId = Math.random().toString(36).substr(2, 9);

  let _r = {
    _rules: null,
    _statuses: [],
    _params: [],
  };

  // Create the request promise and cache it
  const requestPromise = axios
    .get(`${orgID}/licensingruntime/${ruleCollection ? "nr" : "all"}`, {
      headers: { tid: tId },
    })
    .then((res) => {
      // Validate response with tid to prevent race conditions
      if (res.data.tid && res.data.tid !== tId) {
        console.warn(
          `Ignoring stale response for ${cacheKey} (expected tid: ${tId}, got: ${res.data.tid})`
        );
        return;
      }

      _r._rules = ruleCollection
        ? ruleCollection
        : __compileRules(res.data._rules, res.data._statuses);

      _r._statuses = [
        ...res.data._statuses,
        __trackStatus.norule,
        __trackStatus.inprogress,
      ];

      _r._params = [...res.data._params];

      if (_r._rules?.length && _r._params?.length && _r._statuses?.length) {
        // Cache the successful response
        cachedRuntimeData = _r;
        
        dispatch({
          type: actionTypes.LOAD,
          payload: _r,
        });
      } else {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: "runtimeError" },
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
    })
    .finally(() => {
      // Remove from pending cache when complete
      pendingRequests.delete(cacheKey);
    });

  // Store the pending request
  pendingRequests.set(cacheKey, requestPromise);

  return requestPromise;
};

export const resetCatg = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_CTAG,
  });
};

// Clear runtime cache to force refresh on next loadRuntime call
export const clearRuntimeCache = () => {
  cachedRuntimeData = null;
  pendingRequests.clear();
};

export const setCopyLiveIds = (copyLiveIds) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_COPY_LIVE_IDS,
    payload: copyLiveIds,
  });
};

export const removeCopyLiveIds = (id) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_COPY_LIVE_IDS,
    payload: id,
  });
};
